export default __webpack_public_path__ + "92e84b39d730e41d3be4f8e355c2ab43.svg";